"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.scrollToTop = exports.postRefreshPage = exports.postSetTitle = exports.postInnerRoute = exports.postRedirectMessage = exports.postResizeMessage = exports.onIframeUnmount = exports.onIframeMount = void 0;
// import variables from '../styles/_globals.scss';
/* eslint-disable css-modules/no-undef-class */
var getPlatformUrl_1 = __importDefault(require("./getPlatformUrl"));
var getTenant_1 = __importDefault(require("./getTenant"));
var onIframeMount = function (_a) {
    var parentRoute = _a.parentRoute, styles = _a.styles, title = _a.title;
    (0, getTenant_1.default)(); // call to make sure tenant from url params is cached in sessionStorage
    document.body.style.minWidth = 'initial';
    document.body.style.height = 'max-content';
    var rootElement = Object(document.getElementById('root'));
    if (rootElement.style !== undefined) {
        rootElement.style.height = 'initial';
        rootElement.style['overflow-x'] = 'clip';
    }
    window.addEventListener('resize', exports.postResizeMessage);
    if (window.ResizeObserver) {
        // the if is for the tests, where it's not defined
        new ResizeObserver(exports.postResizeMessage).observe(window.document.body);
    }
    (0, exports.postResizeMessage)();
    window.addEventListener('message', handleMessageFromParent);
    if (parentRoute)
        (0, exports.postInnerRoute)(parentRoute);
    if (title)
        (0, exports.postSetTitle)(title);
    if (styles) {
        Object.keys(styles).forEach(function (key) {
            var value = styles[key];
            rootElement.style[key] = value;
        });
    }
};
exports.onIframeMount = onIframeMount;
var onIframeUnmount = function () {
    document.body.style.minWidth = '1280px'; // variables['min-width'];
    // eslint-disable-next-line dot-notation
    Object(document.getElementById('root')).style.height = '100vh'; // variables.height;
};
exports.onIframeUnmount = onIframeUnmount;
// eslint-disable-next-line no-restricted-globals
var platformClientUrl = (0, getPlatformUrl_1.default)();
var postResizeMessage = function () {
    window.parent.postMessage({ type: 'height', value: window.document.body.scrollHeight }, platformClientUrl);
};
exports.postResizeMessage = postResizeMessage;
var postRedirectMessage = function (url) {
    window.parent.postMessage({ type: 'redirect', value: url }, platformClientUrl);
};
exports.postRedirectMessage = postRedirectMessage;
var postInnerRoute = function (parentRoute) {
    window.parent.postMessage({ type: 'innerRoute', value: parentRoute }, platformClientUrl);
};
exports.postInnerRoute = postInnerRoute;
var postSetTitle = function (title) {
    window.parent.postMessage({ type: 'setTitle', value: title }, platformClientUrl);
};
exports.postSetTitle = postSetTitle;
var postRefreshPage = function () {
    window.parent.postMessage({ type: 'refreshPage' }, platformClientUrl);
};
exports.postRefreshPage = postRefreshPage;
var scrollToTop = function () {
    window.parent.postMessage({ type: 'scrollToTop' }, platformClientUrl);
};
exports.scrollToTop = scrollToTop;
var handleMessageFromParent = function (message) {
    if (!message.origin.startsWith(platformClientUrl))
        return;
    var data = message.data;
    if (data.topOffset !== undefined && window.parentScroll !== undefined) {
        window.parentScroll(data.topOffset);
    }
};
